import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { Accounts } from "../api/jobimag/models/accounts";
import { ServerState } from "../api/jobimag/models/server-state";

type AppState = {
    loading: boolean;
    serverState: ServerState | null;
    userAccount: Accounts | null;
};

const initialState: AppState = {
    loading: false,
    serverState: null,
    userAccount: null
};

export const AppStore = signalStore(
    {
        providedIn: "root"
    },
    withState(initialState),
    withMethods((store) => ({
        setLoading(loading: boolean): void {
            patchState(store, { loading });
        },
        setServerState(serverState: ServerState): void {
            patchState(store, { serverState });
        },
        setUserAccount(userAccount: Accounts | null): void {
            patchState(store, { userAccount });
        }
    }))
);
